<template>
  <div class="pc" v-if="isDesktop">
    <!-- <div class="head_in">
      <div class="head_text">
        <div class="head_left">
          <a href="/">
            <img src="../assets/img/logo.png" alt />
          </a>
          <div class="head_text1">
            <span>兰台文化</span>
            <p>培训教育专家</p>
          </div>
        </div>
        <div class="head_right">
          <div class="head_right_top">
            <a href="/about">关于我们</a>
            <a href="/contact">联系我们</a>
            <p v-show="!nuser_in" @click="showDialog">登录/注册</p>
          </div>
          <div class="head_right_bottom">
            <span>咨询热线：</span>
            <p class="Telephone" ig-phone>{{ nowData.tel }}</p>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 当一级路由不是 login 时显示 nav -->
    <div v-if="getFirstLevelRoute() !== 'login'" class="nav">
      <div class="head_left">
        <a href="/">
          <img src="../assets/img/logo.png" alt />
        </a>
        <div class="head_text1">
          <span>兰台文化</span>
          <p>培训教育专家</p>
        </div>
      </div>
      <div class="w clearfix">
        <ul class="clearfix">
          <li
            :class="{ hover: isActive('/') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
          >
            <a href="/" title="网站首页" class>网站首页</a>
          </li>

          <li
            :class="{ hover: isActive('/about') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
          >
            <a href="/about" title="关于我们" class>
              <i>关于我们</i>
            </a>
          </li>

          <li
            :class="{ hover: isActive('/team') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
          >
            <a href="/team" title="师资力量" class>
              <i>师资力量</i>
            </a>
          </li>

          <li
            :class="{ hover: isActive('/zhishi') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
          >
            <a href="/zhishi" title="培训知识" class>
              <i>培训知识</i>
            </a>
          </li>

          <li
            :class="{ hover: isActive('/course') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
          >
            <a href="/course/course_in" title="全部课程" class>
              <i>全部课程</i>
            </a>
          </li>

          <li
            :class="{ hover: isActive('/xueyuan') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
          >
            <a href="/xueyuan" title="学员口碑" class>
              <i>客户案例</i>
            </a>
          </li>

          <li
            :class="{ hover: isActive('/news') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
          >
            <a href="/news" title="新闻资讯" class>
              <i>新闻资讯</i>
            </a>
            <div class="subNav">
              <!-- <a href="/news/gongsi" title="公司新闻">公司新闻</a>
              <a href="/news/hangye" title="行业新闻">行业新闻</a>-->
              <a href="/news/news_in" title="公司新闻">公司新闻</a>
              <a href="/news/news_ins" title="行业新闻">行业新闻</a>
            </div>
          </li>

          <li
            :class="{ hover: isActive('/contact') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
          >
            <a href="/contact" title="联系我们" class>
              <i>联系我们</i>
            </a>
          </li>
          <li
            :class="{ hover: isActive('/user') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
            v-show="!nuser_in"
          >
            <a href="#" title="登录/注册" class @click="showDialog">
              <i>登录/注册</i>
            </a>
          </li>
          <li
            :class="{ hover: isActive('/user') }"
            @mouseenter="showSubMenu($event)"
            @mouseleave="hideSubMenu($event)"
            v-show="nuser_in"
          >
            <a href="/user" title="个人中心" class>
              <i>个人中心</i>
            </a>
          </li>
        </ul>
      </div>
      <div class="head_right_bottom" >
        <span>咨询热线：</span>
        <p class="Telephone" ig-phone>{{ nowData.tel }}</p>
      </div>
    </div>
    <DialogComponent
      :visible.sync="dialogVisible"
      :currentView="currentView"
      :title="title"
      @confirm="handleConfirm"
      @newTitle="newTitle"
      @customEvent="handleChildData"
    >
      <!-- 弹窗内容 -->
      <!-- <p>这里是登录/注册表单内容</p> -->
    </DialogComponent>
  </div>
  <div class="move" v-else>
    <header class="header">
      <div class="logo">
        <a href="/">
          <img
            src="../assets/img/logo.png"
            title="山东兰台文化传播有限公司"
            alt="山东兰台文化传播有限公司"
          />
        </a>
      </div>
      <div class="shownav active" id="showNav" @click="showNavMenu"></div>
    </header>
    <nav
      class="navx animated slideInDown faster"
      id="nav"
      v-if="isNavVisible"
      style="display: block"
    >
      <dl class="list clearfix">
        <dd class="current">
          <a href="/">网站首页</a>
        </dd>

        <dd>
          <a href="/about">关于我们</a>
        </dd>

        <dd>
          <a href="/team">师资力量</a>
        </dd>

        <dd>
          <a href="/zhishi">培训知识</a>
        </dd>

        <dd>
          <a href="/course">全部课程</a>
        </dd>

        <dd>
          <a href="/xueyuan">客户案例</a>
        </dd>

        <dd>
          <a href="/news">新闻资讯</a>
        </dd>

        <dd>
          <a href="/contact">联系我们</a>
        </dd>

        <dd>
          <a href="/user">个人中心</a>
        </dd>

        <dd v-show="!nuser_in">
          <a href="/login">登录</a>
        </dd>
      </dl>
    </nav>
  </div>
</template>

<script>
import method from "@/utils/Untitl.js";
import DialogComponent from "./DialogComponent.vue";
import { mapState } from "vuex";
export default {
  name: "AppHead",
  components: {
    DialogComponent,
  },
  props: {
    nowData: {
      // type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState(["nuser_in"]),
  },
  data() {
    return {
      // 初始化 isDesktop 状态
      isDesktop: window.innerWidth > 428,
      // 初始化导航菜单为隐藏状态
      isNavVisible: false,
      http: process.env.VUE_APP_BASE_API,
      // nowData: [],
      username: localStorage.getItem("username"),
      dialogVisible: false,
      currentView: "login",
      title: "登录/注册",
      isWidth: window.innerWidth <= 2100,
      isWidth1: window.innerWidth <= 1800,
    };
  },
  mounted() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    // this.getNowData();
    this.token();
  },
  methods: {
    handleChildData(data) {
      // 处理子组件传递的数据
      this.currentView = data;
    },
    newTitle(data) {
      // 处理子组件传递的数据
      this.title = data;
    },
    showDialog() {
      this.dialogVisible = true;
      this.currentView = "login";
      this.title = "登录/注册";
    },
    handleConfirm() {
      // 处理确认操作
      console.log("用户点击了确认按钮");
      this.dialogVisible = false;
    },
    token() {
      const token = localStorage.getItem("token");
      if (token) {
        this.username = localStorage.getItem("username");
        this.$store.dispatch("updateNuser_in", true);
        // this.nuser = true
      } else {
        // this.nuser = false
        this.$store.dispatch("updateNuser_in", false);
      }
    },
    // 处理窗口大小变化的方法
    handleResize() {
      this.isDesktop = window.innerWidth > 428;
      this.isWidth = window.innerWidth <= 2100;
      this.isWidth1 = window.innerWidth <= 1800;
    },
    // 显示导航菜单的方法
    showNavMenu() {
      // console.log("显示导航菜单");
      this.isNavVisible = !this.isNavVisible;
    },
    showSubMenu(event) {
      const liElement = event.currentTarget;
      const subNav = liElement.querySelector(".subNav");
      if (subNav) {
        // 临时设置为 auto 获取自然高度
        subNav.style.height = "auto";
        const height = subNav.offsetHeight;
        // 先把高度设置为 0
        subNav.style.height = "0";
        // 下一帧设置实际高度触发过渡动画
        requestAnimationFrame(() => {
          subNav.style.height = `${height}px`;
        });
      }
    },
    hideSubMenu(event) {
      const liElement = event.currentTarget;
      const subNav = liElement.querySelector(".subNav");
      if (subNav) {
        subNav.style.removeProperty("height");
      }
    },
    isActive(routePath) {
      // 提取当前路由的一级路径
      const currentFirstLevelPath =
        this.$route.path.split("/")[1].split("_")[0] || "";
      // 提取传入路由的一级路径
      const targetFirstLevelPath = routePath.split("/")[1] || "";
      //// console.log(currentFirstLevelPath,targetFirstLevelPath);
      return currentFirstLevelPath === targetFirstLevelPath;
    },
    // 提取一级路由的方法
    getFirstLevelRoute() {
      return this.$route.path.split("/")[1] || "";
    },
    // async getNowData() {
    //   const res = await method.index();
    //   if (res.code == 1) {
    //     this.nowData = res.data.info;
    //   }
    // },
  },
  //  watch: {
  //   nuser() {
  //     this.token();
  //   }
  // },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/pc/head.scss";
@import "@/assets/css/move/head.scss";
</style>
